import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("selec_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("selec_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("selec_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("selec_token");
    setUser(null);
  };

  const refreshMe = async () => {
    const res = await api.get("/auth/me");
    setUser(res.data);
  };

  const switchRole = async (roleId) => {
    const { data } = await api.post("/auth/switch-role", { role_id: roleId });
    localStorage.setItem("selec_token", data.token);
    window.location.reload();
  };

  // Cierre de sesión automático por inactividad: DESACTIVADO a pedido del usuario.

  const can = (perm) => !!user && (user.is_admin || (user.permissions || []).includes(perm));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, refreshMe, switchRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
